import { useCallback } from "react";
import { nanoid } from "nanoid";
import { FilterButtonV2 } from "@/react/components/shared/FilterV3/FilterButtonV2";
import { useFilterProvider } from "../FilterProvider";
import type { PresetFilterConfiguration } from "../types";

interface PresetFilterInputProps {
  configuration: PresetFilterConfiguration;
}

export const PresetFilterInput = ({
  configuration,
}: PresetFilterInputProps) => {
  const { setFilter, clearFilterByKey, filterParamForKey } =
    useFilterProvider();

  const currentPresetFilter = filterParamForKey(
    configuration.payload.preset_params.key,
  );

  const hasValue = Boolean(currentPresetFilter);

  const handleClick = useCallback(() => {
    const presetParams = configuration.payload.preset_params;

    if (presetParams && typeof presetParams === "object") {
      const id = nanoid();
      const filter = {
        id,
        ...presetParams,
      };
      setFilter(configuration.payload.preset_params.key, {
        ...filter,
        search_key: configuration.search_key,
      });
    }
  }, [configuration.payload.preset_params, setFilter]);

  const handleClear = useCallback(() => {
    if (!currentPresetFilter) return;
    clearFilterByKey(currentPresetFilter.key);
  }, [currentPresetFilter, clearFilterByKey]);

  return (
    <FilterButtonV2
      hasValue={hasValue}
      onClick={handleClick}
      onClear={handleClear}
    >
      <span className="text-dark text-sm font-medium leading-5">
        {configuration.label}
      </span>
    </FilterButtonV2>
  );
};
